<template>
  <div style="margin-top: 100px;margin-bottom: 50px">
    <span>Resource  </span>
    <input disabled placeholder="Type Resource ID"  v-model="resource_ID" style="padding: 10px 10px;width: 25%"> {{resource_ID.length}}
    <br><br>
    <button class="upload" @click="sendHerokuPOST">Heroku AddOn service</button>
    <br><br>
    <button class="upload" @click="sendHerokuDELETE">Heroku AddOn delete</button>
    <br><br>
    <button class="upload" @click="sendHerokuPlanChange">Heroku AddOn change plan to : {{plan}}</button>
    <br><br>
    <select v-model="plan">
      <option value="free">Free</option>
      <option value="silver">Silver</option>
      <option value="gold">Gold</option>
      <option value="test">Test</option>
    </select>
    <br><br>
    <button class="upload" @click="redirectToSSO">Heroku SSO with fetch</button>
    <br>
    <br>
    <form :action="alink" method="POST" style="background-color: lightskyblue;padding: 10px 10px">
      <h3> Heroku SSO with form / action </h3>
      <label for="rid">Resource ID:</label>
      <input type="text" id="rid" name="resource_id" v-model="resource_ID"><br><br>
      <label for="app_name" >App name:</label>
      <input type="text" id="appname" name="app_name" v-model="app_name"><br><br>
      <label for="token">Token:</label>
      <input type="text" id="token" name="resource_token" v-model="resource_token"><br><br>
      <label for="timestamp">Timestamp:</label>
      <input type="text" id="timestamp" name="timestamp" v-model="timestamp"><br><br>
      <label for="sso">(client)_SSO_URL:</label>
      <input disabled type="text" id="sso" name="sso_url" v-model="sso_url"><br><br>
      <label for="server">(service)_SSO_URL:</label>
      <input disabled type="text" id="server" v-model="alink"><br><br>
      <input type="submit" value="Submit">
    </form>
    <br><br>
    <button class="upload" @click="sendHerokuGET">Heroku DB info</button>
    <br><br>
    <label for="0">Maintenance</label>
    <input type="radio"  v-model="fileID" value="0" id="0">
    <label for="1">Gold/Silver plan</label>
    <input type="radio"  v-model="fileID" value="1" id="1">
    <label for="2">Free plan</label>
    <input type="radio"  v-model="fileID" value="2" id="2">
    <br>
    <br>
    <div style="display: block;width: 100%;max-width: 100%">
      <textarea rows="8" v-model="text"  style="font-size: 10px;width: 100%" ></textarea>
    </div>
    <br><br>
    <span style="display:block;font-size: 12px;margin-top: 10px" v-for="(client,index) in mntAk " :key="index">
      {{index}} - <b>UUID: </b>{{client.uuid}} <b>AKEY: </b> {{getAK(client.sign_in)}}
    </span>
    <br><br>
    <button @click="getPaymentStats"> Stats</button>
    <div style="display: block;width: 100%;max-width: 100%">
      <textarea rows="8" v-model="payment_stats"  style="font-size: 10px;width: 100%" ></textarea>
    </div>
    <br><br>
    <button class="upload" @click="getFreeClients"> Get trial clients from DB / SAPPO </button>
    <div v-if="t_clients.length === 0">No clients</div>
    <span v-else style="display: block;font-size: 12px;margin-top: 10px" v-for="(c,index) in t_clients" :key="index">
      {{index}} &nbsp;&nbsp;{{c}} &nbsp;<button @click="deleteClient(c.id)">delete</button><br>
    </span>

    <br><br>
    <button class="upload" @click="getPayingClients"> Get paying clients from DB / SAPPO </button>
    <div v-if="p_clients.length === 0">No clients</div>
    <span v-else style="display: block;font-size: 12px;margin-top: 10px" v-for="(c,index) in p_clients" :key="index">
      {{index}} &nbsp;&nbsp;{{c}} &nbsp;<button>delete</button><br>
    </span>
    <br><br>
    <button @click="generateClient" >Generate Resource in ClientTable</button>
  </div>
</template>
<script>
import {getBaseURL} from "../../url_endpoints";
import {generateHID, get_UPAYS_auth} from "@/components/hid";

export default {
  name: 'UpayHeroku',
  data() {
    return {
      mnt:null,
      text:'',
      fileID:'0',
      mntAk:[],
      resource_ID:"01234567-89ab-cdef-0123-456789abcdef",
      app_name:'EyesOnFood',
      sso_url: 'https://upays-client-2fd5d321b077.herokuapp.com/hsso',
      resource_token: '1f64d1d2585ec1f68dffab20019622b3a6ead9e4',
      timestamp: 1737702632373,
      no_auth:true,
      plan:'free',
      alink:'',
      payment_stats:'',
      t_clients:[],
      p_clients:[],
    }
  },
  mounted(){
    //let code = this.generateCredential('pipi'+process.env.VUE_APP_CLIENT_STRIPE_LIVE)
    //let tdata = atob(code).split('pipi')
    //console.log('prefix: '+tdata[0])
    //console.log('code: '+tdata[1])
    this.setActionLink()
  },
  methods: {
    showInfo(msg){
      let x = prompt('This is my AC',msg)
      alert(x) //console.log(x)
    },
    setActionLink() {
      if(process.env.NODE_ENV === 'production') {
        this.alink = "https://upays-server-031285db46a4.herokuapp.com/heroku/sso"
        this.sso_url = 'https://upays-client-2fd5d321b077.herokuapp.com/hsso'
      }else {
        this.alink = "http://localhost:3000/heroku/sso"
        this.sso_url = 'http://localhost:8080/hsso'
      }
    },
    getAK(s){
      return atob(s)
    },
    generateCredential(element) {
      const ucode = btoa(element)
      console.log(element +' : '+ucode)
      return ucode
    },
    redirectToSSO(){
      const uuid = this.resource_ID.length > 0 ? this.resource_ID : "01234567-89ab-cdef-0123-456789abcdef"
      const baseURL = getBaseURL()
      let username = 'upays-staging'
      let password = 'K12gk7Pi4r8z7Y5kVylh1jGLIFSDF4eX'
      let auth = btoa(`${username}:${password}`)
      let sso = {
        sso_url: 'https://upays-client-2fd5d321b077.herokuapp.com/hsso',
        resource_id:uuid,
        resource_token: '1f64d1d2585ec1f68dffab20019622b3a6ead9e4',// TEST MODE - computed token for a timestamp,
        timestamp: 1737702632373, // TEST MODE -  timestamp
        app_name:'EyesOnFood'
      }
      let rspSTATUS = 400
      fetch(baseURL + '/heroku/sso', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Authorization': `Basic ${auth}`,
          'Content-Type': 'application/json',
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(sso),
      }).
      then( response => {
        if(response.status === 500){
          rspSTATUS = 500
        }
        return response.json()
        //return response
      }).then( rsp => {
        if(rspSTATUS === 500){
          alert(rsp['message'])
          this.$router.push('/'+rspSTATUS)
        }else {
          window.location.href = rsp['url']
        }
      }).catch((err) => {
        alert('fetch /heroku/sso catch error\n'+ err.message)
        this.$router.push('/'+rspSTATUS)
      })
    },
    getPaymentStats() {
      const baseURL = getBaseURL()
      const tk ='29bd7df4f45da9d7a12bde4112cf25db97db6d0qf6b98f130b64cfe9a6a2b12e'
      fetch(baseURL+'/admin/stats?tk='+tk, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.heroku-addons+json; version=3',
        }
      }).then(res => {
        return res.json()
      }).then( rsp => {
        if(rsp['stat']){
          for(let key in rsp['stats']){
            this.payment_stats += JSON.stringify(rsp['stats'][key])
          }

        }else {
          alert(rsp['error'])
        }
      }).catch( () => {
        alert('Stats unexpected error!')
      })
    },
    sendHerokuGET(){
      const baseURL = getBaseURL()
      let username = 'mee is a symbol'
      let password = 'just support him'
      let auth = btoa(`${username}:${password}`)
      fetch(baseURL+'/admin/mnt?file='+this.fileID, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Authorization': `Basic ${auth}`,
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.heroku-addons+json; version=3',
        }
      }).then(res => {
        return res.json()
      }).then(data => {
        if(data['auth']) {
          this.text=''
          this.mntAk = []
          this.mnt = data['db']
          if(this.fileID === '0'){
            this.mntAk = data['db']
          }
          /* test if data send by the server*/
          if(data['db'].length > 0){
            for(let key in data['db']) {
              this.text += JSON.stringify(data['db'][key])+'\n'
            }
          }else {
            this.text += '[]'
          }

        }
      }).catch( (error) => {
        alert('fetch /admin/mnt catch error\n'+ error.message)
      })
    },
    sendHerokuPlanChange(){
      const uuid = this.resource_ID.length > 0 ? this.resource_ID : "01234567-89ab-cdef-0123-456789abcdef"
      const baseURL = getBaseURL()
      let username = 'upays-staging'
      let password = 'K12gk7Pi4r8z7Y5kVylh1jGLIFSDF4eX'
      let auth = btoa(`${username}:${password}`)
      fetch(baseURL+'/heroku/resources/'+uuid, {
        method: 'PUT',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Authorization': `Basic ${auth}`,
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.heroku-addons+json; version=3',
        },
        body: JSON.stringify({plan:this.plan})
      }).then(res => {
        return res.json()
      }).then(data => {
        alert(data['message'])
      }).catch( err =>
          alert('fetch /heroku/resources plan change catch error\n'+ err.message)
      )
    },
    sendHerokuDELETE() {
      const uuid = this.resource_ID.length > 0 ? this.resource_ID : "01234567-89ab-cdef-0123-456789abcdef"
      const baseURL = getBaseURL()
      let username = 'upays-staging'
      let password = 'K12gk7Pi4r8z7Y5kVylh1jGLIFSDF4eX'
      let auth = btoa(`${username}:${password}`)
      fetch(baseURL+'/heroku/resources/'+uuid, {
        method: 'DELETE',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Authorization': `Basic ${auth}`,
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.heroku-addons+json; version=3',
        },
      }).then( rsp => {
        return rsp
      }).then( response => {
        if(response.status === 204){
          alert('delete success!')
        }else {
          alert('resource not found')
        }
      }).catch(error => {
        alert('fetch /heroku/resources delete catch error\n'+ error.message);
      })
    },
    sendHerokuPOST() {
      const baseURL = getBaseURL()
      // The username and password
      // DO NOT store credentials in your JS file like this
      let username = 'upays-staging'
      let password = 'K12gk7Pi4r8z7Y5kVylh1jGLIFSDF4eX'
      let auth = btoa(`${username}:${password}`)
      const add_on = {
       // callback_url: "https://api.heroku.com/addons/01234567-89ab-cdef-0123-456789abcdef",
        name: "acme-inc-primary-database",
        oauth_grant: {
          code: "71234567-89ab-cdef-0123-456789abcdef",
          expires_at: "2016-03-03T18:01:31-0800",
          type: "authorization_code"
        },
        options: { "foo" : "bar", "baz" : "true" },
        plan: this.plan,
        region: "amazon-web-services::us-east-1",
        uuid: this.resource_ID.length > 0 ? this.resource_ID : "01234567-89ab-cdef-0123-456789abcdef",
        log_input_url: "https://token:t.01234567-89ab-cdef-0123-456789abcdef@1.us.logplex.io/logs",
        log_drain_token: "d.01234567-89ab-cdef-0123-456789abcdef"
      }
      // Authenticate (dummy API)
      fetch(baseURL + '/heroku/resources', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Authorization': `Basic ${auth}`,
          'Content-Type': 'application/json'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(add_on),
      }).then( response => {
        return response.json()
      }).then( rsp => {
        if(rsp['id'] === 'verification_needed') {
          alert(rsp['id'] +'\n'+rsp['message'])
        }else {
          alert(rsp['id'] + ' added successfully.\n'+rsp['message'])
        }
      }).catch(error => {
        alert('fetch /heroku/resources catch error:\n '+ error.message)
      })
    },
    getPayingClients() {
      let baseURL = getBaseURL()
      let auth = get_UPAYS_auth()
      fetch(baseURL+"/clients/paying", {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Authorization': `Basic ${auth}`,
          'Content-Type': 'application/json'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
      }).then(response => {
        return response.json()
      }).then( rsp => {
        //console.log(rsp)
        this.p_clients = rsp['clients']
      }).catch( () => {
        this.$router.push('/500')
      })
    },
    getFreeClients() {
      let baseURL = getBaseURL()
      let auth = get_UPAYS_auth()
      fetch(baseURL+"/clients/trials", {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Authorization': `Basic ${auth}`,
          'Content-Type': 'application/json'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
      }).then(response => {
        return response.json()
      }).then( rsp => {
        //console.log(rsp)
        this.t_clients = rsp['clients']
      }).catch( () => {
        this.$router.push('/500')
      })
    },
    deleteClient(id) {
      let baseURL = getBaseURL()
      let auth = get_UPAYS_auth()
      fetch(baseURL+"/clients/delete/trial/"+id, {
        method: 'DELETE',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Authorization': `Basic ${auth}`,
          'Content-Type': 'application/json'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
      }).then(response => {
        return response.json()
      }).then( rsp => {
        alert(rsp)
        //console.log(rsp)
      }).catch( () => {
        this.$router.push('/500')
      })
    },
    generateClient(){
      /*  register new client [paying] to the DB */
      const baseURL = getBaseURL()
      const auth = get_UPAYS_auth()
      /* generate a string for website name */
      const gname  = generateHID(Date.now().toString())
      const weblink = 'www.'+gname.substring(3,15) +'.com'
      //console.log(weblink)
      fetch(baseURL+"/clients/register/clients", {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Authorization': `Basic ${auth}`,
          'Content-Type': 'application/json'
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify({weblink:weblink,c_keys:true})
      }).then(response => {
        return response.json()
      }).then( rsp => {
        if(rsp['auth']) {
          if(rsp["akey"]) {
            /* set sign in ok */
            localStorage.setItem('akey',rsp["akey"])
            alert('Generated Key:\n'+rsp["akey"])
          }else {
            alert('No Key generated')
          }
        }else {
          alert('No auth...cause:\n'+rsp['message'])
        }
      }).catch( () => {
        alert('Error when POST resource!')
      })
    },
  }
}
</script>
<style scoped>
.upload {
  font-size: 14px;
  color: black;
  opacity: 0.6;
  border-radius: 8px;
  border: none;
}
.upload:hover {
  cursor: pointer;
  font-size: 17px;
  color: green;
  opacity: 0.9;
}
label {
  margin-left: 20px;
  font-size: 11px;
}
input[type=text] {
  width: 30%;
}
</style>